export const SET_DEPARTURE = 'SET_DEPARTURE';  
export const SET_ARRIVAL = 'SET_ARRIVAL';  
export const SET_DEPARTURE_LIST = 'SET_DEPARTURE_LIST';  
export const SET_ARRIVAL_LIST = 'SET_ARRIVAL_LIST';  
export const SET_START_DATE = 'SET_START_DATE';  
export const SET_END_DATE = 'SET_END_DATE';  
export const SET_DATES = 'SET_DATES';  
export const SET_IS_ROUND_TRIP = 'SET_IS_ROUND_TRIP';  


export const SET_OUTGOING_TRIPS = "SET_OUTGOING_TRIPS"
export const SET_INCOMING_TRIPS = "SET_INCOMING_TRIPS"
export const SET_OUTGOING_DESTINATION_TRIPS = "SET_OUTGOING_DESTINATION_TRIPS"
export const SET_INCOMING_DESTINATION_TRIPS = "SET_INCOMING_DESTINATION_TRIPS"
export const SELECT_OUTGOING_TRIP = "SELECT_OUTGOING_TRIP"
export const SELECT_INCOMING_TRIP = "SELECT_INCOMING_TRIP"
export const SET_SEARCH_PARAMETERS = "SET_SEARCH_PARAMETERS"
export const SET_USER_SELECTED_DEPARTURE_TRIP = "SET_USER_SELECTED_DEPARTURE_TRIP"
export const SET_USER_SELECTED_RETURN_TRIP = "SET_USER_SELECTED_RETURN_TRIP"

export const SET_AGENCIES_COUNTRY_ID = "SET_AGENCIES_COUNTRY_ID"
export const SET_AGENCIES_PERFECTURE_ID = "SET_AGENCIES_PERFECTURE_ID"
export const SET_AGENCIES_MUNICIPALITY_ID = "SET_AGENCIES_MUNICIPALITY_ID"
export const SET_AGENCIES_LIST = "SET_AGENCIES_LIST"

export const SET_TRIP_AGENCIES_COUNTRY_ID = "SET_TRIP_AGENCIES_COUNTRY_ID"
export const SET_TRIP_AGENCIES_PERFECTURE_ID = "SET_TRIP_AGENCIES_PERFECTURE_ID"
export const SET_TRIP_AGENCIES_MUNICIPALITY_ID = "SET_TRIP_AGENCIES_MUNICIPALITY_ID"
export const SET_TRIP_AGENCIES_LIST = "SET_TRIP_AGENCIES_LIST"

export const SET_EVENTS_LOCATION_CODE = "SET_EVENTS_LOCATION_CODE"
export const SET_EVENTS_EVENTTYPE_ID = "SET_EVENTS_EVENTTYPE_ID"
export const SET_EVENTS_MAXEVENTS_SIZE = "SET_EVENTS_MAXEVENTS_SIZE"
export const SET_EVENTS_DATE = "SET_EVENTS_DATE"
export const SET_EVENTS_LIST = "SET_EVENTS_LIST"

export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE"


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js